import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import type { MESSAGE_ICON_TYPE } from "@/constants/message-icon";
import { ICON_CONFIG, MESSAGE_ICON } from "@/constants/message-icon";

type AppAlertWithDialogProps = {
  open: boolean;
  iconType: MESSAGE_ICON_TYPE;
  message: string;
  subMessage?: string;
  onOpenChange: (open: boolean) => void;
};

export function AppAlertWithIconDialog({
  open,
  iconType,
  message,
  subMessage,
  onOpenChange,
}: AppAlertWithDialogProps) {
  const config = ICON_CONFIG[iconType] || ICON_CONFIG[MESSAGE_ICON.INFO];
  const { Icon, iconColor } = config;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader className="flex flex-col items-center justify-center space-y-3">
          <div className="flex justify-center rounded-full p-4">
            <Icon className={`size-12 ${iconColor}`} strokeWidth="1.5px" />
          </div>

          <AlertDialogTitle className="text-lg">{message}</AlertDialogTitle>

          {subMessage && (
            <AlertDialogDescription className="text-sm text-muted-foreground">
              {subMessage}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>

        <AlertDialogFooter className="mt-4">
          <AlertDialogAction
            className="w-full content-center outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            autoFocus
          >
            <Button
              type="button"
              className="min-w-24 bg-primary hover:bg-primary-selected"
            >
              OK
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
